module.exports = __webpack_public_path__ + "static/img/Rectangle285.ac38198d.png";